export default __webpack_public_path__ + "static/media/4.ab0b937c.jpg";